import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=33a3afd8&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3afd8",
  null
  
)

export default component.exports